import { render, staticRenderFns } from "./StatisticLoader.vue?vue&type=template&id=4a68ded2"
import script from "./StatisticLoader.vue?vue&type=script&lang=ts"
export * from "./StatisticLoader.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports